import React from "react";

const Seprator = () => {
  return (
    <div
      className="h-[6px] w-[35%] 
    bg-gradient-to-r bg from-indigo-500 via-purple-500 to-blue-600 my-4"
    ></div>
  );
};

export default Seprator;
